import { render, staticRenderFns } from "./LabSpectroscope.vue?vue&type=template&id=22546d3a&"
import script from "./LabSpectroscope.vue?vue&type=script&lang=ts&"
export * from "./LabSpectroscope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports